import React from 'react';
import {
	Box,
	DividerLine,
	DividerLineProps,
	Typography,
	Image,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { DisplayCost } from './displayCost';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Anything, Color } from '@types';
import { rem } from '@helpers';
import { imagesBcp } from '@assets';

export interface CostSummarySubscriptionProps {
	name: string;
	monthsPromotion: number;
	discountPrice: number;
	mainPrice: number;
	hasPromotionalCode: boolean;
}

const flexSettings = {
	justifyContent: 'space-between',
	alignItems: 'center',
};

export const CostSummarySubscription: React.FC<CostSummarySubscriptionProps> = (props) => {
	const { name, monthsPromotion, discountPrice, mainPrice, hasPromotionalCode } = props;
	const { palette } = useTheme();
	const t = useTranslation();

	const discountDurationText = t('placeholders.costSummary.promotionalCodeDuration', {
		months: monthsPromotion,
	});

	return (
		<>
			<Box styles={{ ...flexSettings }}>
				<Box
				// styles={{
				// 	backgroundColor: palette.global.ui18,
				// 	borderRadius: rem(16),
				// 	overflow: 'hidden',
				// 	backfaceVisibility: 'hidden',
				// }}
				>
					<Image source={imagesBcp.planTitleBrand} />
					<Box styles={{ alignItems: 'center', padding: rem(0, 40, 0, 8) }}>
						<Typography
							appearance="subtitle-200-02"
							alternativeStyleProperties={{ color: Color.Izibizi } as Anything}
						>
							{name}
						</Typography>
					</Box>
				</Box>
				{hasPromotionalCode && (
					<>
						<Box
							styles={{
								margin: '0 16px 0 auto',
								borderRadius: '4px',
								backgroundColor: '#D1005D33',
								padding: '2px 8px',
							}}
						>
							<Typography appearance="microcopy-75-07" colorsLevel="secondary">
								{discountDurationText}
							</Typography>
						</Box>
					</>
				)}
				<DisplayCost
					cost={hasPromotionalCode ? discountPrice : mainPrice}
					appearance={hasPromotionalCode ? 'promotionalMain' : 'main'}
				/>
			</Box>
			{hasPromotionalCode && <DividerLine {...({ margin: rem(16, 0) } as DividerLineProps)} />}
		</>
	);
};
